import { Partition } from '../types/Partition';
import { partitionToDate } from './partitionToDate';

export const comparePartitions = (a: Partition, b: Partition): number => {
  return partitionToDate(a).toMillis() - partitionToDate(b).toMillis();
};
